import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { Card, CardAction, CardContent, CardHeader, CardTitle } from '../ui/card';

type Props = {
  onDelete: () => void;
  description?: string;
  showDelete?: boolean;
  primaryAction?: {
    label: string;
    href?: string;
    onClick?: () => void;
    variant?: 'primary' | 'secondary' | 'ghost' | 'outline';
  };
  secondaryAction?: {
    label: string;
    href?: string;
    onClick?: () => void;
    variant?: 'primary' | 'secondary' | 'ghost' | 'outline';
  };
};

export default function DemoPatientBanner({
  onDelete,
  description = 'Questo è un cliente di esempio: usalo per esplorare chat, diario e AI. Eliminalo quando vuoi.',
}: Props) {
  const handleClick = () => {
    if (!window.confirm('Vuoi eliminare questo cliente demo?')) return;
    onDelete();
  };

  return (
    <Card semantic="destructive">
      <CardHeader>
        <CardTitle>Cliente demo attivo</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm">{description}</p>
        <CardAction className="flex flex-wrap gap-2">
          <Button variant="destructive" size="sm" className="gap-2" onClick={handleClick}>
            <Trash2 className="h-4 w-4" />
            Elimina
          </Button>
        </CardAction>
      </CardContent>
    </Card>
  );
}
